import React from 'react'
import classNames from 'classnames'
import ChipDropdown from 'components/ChipDropdown'
import Comment from '../../../Comment/index'
import './AskVisoSuggestions.scss'

const AskVisoSuggestions = ({ color, setPromptValue, chatId, isFullscreen, suggestions = [], isFooter }) => {

  return (
    <div className={classNames('ask-viso-suggestions', isFullscreen && 'ask-viso-suggestions--fullscreen', isFooter && 'ask-viso-suggestions--footer')}>
      <Comment
        commentFooter={suggestions?.length > 0 &&
          <div className='ask-viso-chat__suggestions'>
            {suggestions.map((suggestion, index) => (
              <ChipDropdown
                key={index}
                label={suggestion}
                color='outline'
                background='body-bg'
                labelOnly
                onClick={() => setPromptValue(suggestion, chatId)}
              />
            ))}
          </div>
        }
        contentClass={'ask-viso-chat-message__comment'}
        showAvatar
        hideName
        firstName='A'
        lastName='I'
        color={color}
        text='You could also ask me:'
      />
    </div>
  )
}

export default AskVisoSuggestions